// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import CrownOutlined from 'X:/workflow/frontend/node_modules/.pnpm/@ant-design+icons@4.8.3_rea_4f4175561f8cfd0ec686c22d621967e2/node_modules/@ant-design/icons/es/icons/CrownOutlined';
import TableOutlined from 'X:/workflow/frontend/node_modules/.pnpm/@ant-design+icons@4.8.3_rea_4f4175561f8cfd0ec686c22d621967e2/node_modules/@ant-design/icons/es/icons/TableOutlined';
export default { CrownOutlined, TableOutlined };
